module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BoldSemiExtIt.bcaa629.eot";